import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  assignTasksTo, unassignTasks, reloadTxnOpps, setConfirmationModalState, submitPreScreenToUnderwrite,
  terminateTxnOpps, unterminateTxnOpps, syncPurchaseState, appNotify, setViewContainersDialogIsOpen
} from 'store/actions';
import { ButtonDropdown, OpportunityStatusChip } from 'components/layout';
import EditOpportunityModal from 'components/underwrite/acquisition/propertyUnderwrite/header/EditOpportunityModal';
import TerminateModal from 'components/underwrite/acquisition/channelWorkflow/TerminateModal';
import { GetContextMenu } from 'api/shared/contextMenu';
import { Constants } from 'utilities/constants';
import { ImgWithRetry } from 'components/layout';

const HeaderImage = ({ classes, user, selectedOpportunity, selectedOpportunityImages, viewOppOnChannelWorkflow,
  goToAuctionClick, assignTasksTo, unassignTasks, terminateTxnOpps, unterminateTxnOpps, reloadTxnOpps, submitPreScreenToUnderwrite, setConfirmationModalState, hasInspection,
  inspectionClick, selectedContainer, syncPurchaseState, appNotify, setViewContainersDialogIsOpen, viewUnderwriteModalIsOpen }) => {

  const [editOpportunityModalIsOpen, setEditOpportunityModalIsOpen] = useState(false);
  const [isTerminateModalOpen, setIsTerminateModalOpen] = useState(false);
  const [contextMenuData, setContextMenuData] = useState([]);
  const [contextMenuIsLoading, setContextMenuIsLoading] = useState(false);
  useEffect(() => {
    setContextMenuData([]);
    setContextMenuIsLoading(false);
  }, [selectedOpportunity]);

  const fetchContextMenuData = async () => {
    setContextMenuIsLoading(true);
    setContextMenuData([]);

    try {
      let contextMenuFetchedData = await GetContextMenu([selectedOpportunity.id], 'OpportunityUnderwrite', selectedOpportunity.channelText);
      if (viewUnderwriteModalIsOpen) {
        contextMenuFetchedData = contextMenuFetchedData.filter(el => el.action !== 'ViewOpportunityInChannelWorkflow');
      }
      let menuItems = contextMenuFetchedData.map(item => {
        let clickHandler = () => console.log(`No click handler found for ${item.action}`);
        let itemName = item.actionDisplayName;
        let disabled = !item.enabled;
        switch (item.action) {
          case 'CopyRow': {
            clickHandler = () => copyToClipboard(selectedOpportunity.id);
            itemName = 'Copy ID to clipboard';
            break;
          }
          case 'ViewInspection': {
            clickHandler = () => inspectionClick();
            itemName = 'View inspection';
            break;
          }
          case 'SyncPurchaseState': {
            clickHandler = () => handleManualCrmSync(selectedOpportunity.id);
            itemName = 'Sync purchase state';
            disabled = disabled || selectedContainer?.viewingReadonlyMode;
            break;
          }
          case 'AssignOpportunityToMe': {
            clickHandler = () => handleAssign();
            itemName = 'Assign opportunity to me';
            break;
          }
          case 'UnassignOpportunityFromMe': {
            clickHandler = () => handleUnassign();
            itemName = 'Unassign opportunity from me';
            break;
          }
          case 'OpenAuction': {
            clickHandler = () => goToAuctionClick();
            itemName = 'Go to auction';
            break;
          }
          case 'ViewOpportunityInChannelWorkflow': {
            clickHandler = () => viewOppOnChannelWorkflow(selectedOpportunity.id);
            itemName = 'View on Workflow';
            break;
          }
          case 'ViewReloads': {
            clickHandler = () => setViewContainersDialogIsOpen(true);
            itemName = 'View Reloads';
            break;
          }
          case 'ReloadOpportunity': {
            clickHandler = () => handleReloadTxnOppData(selectedOpportunity.id);
            itemName = 'Reload opportunity';
            disabled = disabled || selectedContainer?.viewingReadonlyMode;
            break;
          }
          case 'EditOpportunity': {
            clickHandler = () => handleEditTxnOppData(selectedOpportunity.id);
            itemName = 'Edit opportunity';
            disabled = disabled || selectedContainer?.viewingReadonlyMode;
            break;
          }
          case 'TerminateOpportunity': {
            clickHandler = () => handleOpenTerminate();
            itemName = 'Terminate opportunity';
            disabled = disabled || selectedContainer?.viewingReadonlyMode;
            break;
          }
          case 'UnterminateOpportunity': {
            clickHandler = () => handleUnterminate();
            itemName = 'Unterminate opportunity';
            disabled = disabled || selectedContainer?.viewingReadonlyMode;
            break;
          }
          case 'SubmitToUnderwriting': {
            clickHandler = () => handleSubmitToUW();
            itemName = 'Submit to underwriting';
            break;
          }
          default:
            break;
        }
        return {
          text: itemName,
          disabled,
          onItemClick: clickHandler
        }
      });
      setContextMenuData(menuItems);
    } catch (e) {
      appNotify(e.message, 'error');
    }
    setContextMenuIsLoading(false);
  }

  function copyToClipboard(string) {
    const focusEl = document.activeElement
    const dummy = document.createElement('textarea');
    focusEl.appendChild(dummy); // When in viewValuationDialog, MUI enforces focus on the dialog, preventing the dummy from selecting if appended to body. Append to element in dialog instead (potentially visible if it runs slow, can either look into hiding or just disableEnforceFocus for dialog)
    dummy.value = string;
    dummy.select();
    document.execCommand('copy');
    focusEl.removeChild(dummy);
  }

  const handleReloadTxnOppData = () => {
    const { opportunityStatus, isPostAcquisitionUnderwrite } = selectedOpportunity;
    const willChangeToPostAcq = opportunityStatus === Constants.OpportunityStatus.COMPLETED && isPostAcquisitionUnderwrite === false;
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleReloadTxnOppsConfirmation(selectedOpportunity.id),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to reload transaction opportunity ${selectedOpportunity.id}? This will archive existing data and pull latest information.`,
      warningText: willChangeToPostAcq ? 'This opportunity will be moved into post-acquisitions mode.' : ''
    });
  }
  const handleEditTxnOppData = () => {
    setEditOpportunityModalIsOpen(true);
  }

  function handleReloadTxnOppsConfirmation(selectedOpportunityId) {
    closeConfirmationModal();  // close confirm modal first
    reloadTxnOpps([selectedOpportunityId]);
  };
  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const handleAssign = () => {
    assignTasksTo('txnOpp', [selectedOpportunity.id], user.id, user.id);
  }

  const handleUnassign = () => {
    unassignTasks('txnOpp', [selectedOpportunity.id], user.id);
  }

  const handleSubmitToUW = () => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleSubmitToUWConfirmation(selectedOpportunity.id),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to submit transaction opportunity ${selectedOpportunity.id} to underwriting?`
    });
  }

  const handleSubmitToUWConfirmation = selectedOpportunityId => {
    closeConfirmationModal();  // close confirm modal first
    console.log(selectedOpportunityId + ' submitted to underwriting');
    submitPreScreenToUnderwrite([selectedOpportunityId]); // Endpoint accepts array of txnOppIds
  }

  function handleOpenTerminate() {
    setIsTerminateModalOpen(true);
  }
  function terminateTasks(selectedReason) {
    terminateTxnOpps([selectedOpportunity.id], selectedReason);
    if (isTerminateModalOpen) setIsTerminateModalOpen(false);
  }

  function handleUnterminate() {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleUnterminateConfirmation(selectedOpportunity.id),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to unterminate transaction opportunity ${selectedOpportunity.id}?`
    });
  }
  function handleUnterminateConfirmation(txnOppId) {
    unterminateTxnOpps([txnOppId]);
    closeConfirmationModal();
  }
  const handleManualCrmSync = () => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleManualCrmSyncConfirmation(selectedOpportunity.id),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to sync purchase state for transaction opportunity ${selectedOpportunity.id}?`
    });
  };
  const handleManualCrmSyncConfirmation = (txnOppId) => {
    syncPurchaseState([txnOppId]);
    closeConfirmationModal();
  }

  const handleSelect = item => {
    item.onItemClick();
  }

  return (
    <div className={classes.container}>
      {selectedOpportunityImages?.length &&
        <ImgWithRetry alt="main-property" className={classes.headerImage} src={selectedOpportunityImages[0].images[0].imageUrl} retryCount={2}/>
      }
      <div className={classes.overlayContainer}>
        <OpportunityStatusChip
          txnOpp={selectedOpportunity}
        />
        <ButtonDropdown
          title={`ID ${selectedOpportunity.id}`}
          items={contextMenuData}
          isLoading={contextMenuIsLoading}
          openCallback={fetchContextMenuData}
          onSelect={handleSelect}
          size='tiny'
          style={{
            margin: 0,
            color: '#fff',
            background: 'rgba(0, 0, 0, 0.7)',
            '&:hover': {
              background: 'rgba(0, 0, 0, 0.5)'
            }
          }}
        />
        <EditOpportunityModal
          open={editOpportunityModalIsOpen}
          handleClose={() => setEditOpportunityModalIsOpen(false)}
        />
        <TerminateModal
          txnOpps={[selectedOpportunity]}
          isOpen={isTerminateModalOpen}
          setIsOpen={setIsTerminateModalOpen}
          terminateTasks={terminateTasks}
          singleOpp
        />
      </div>
    </div>
  )
};

const styles = theme => ({
  container: {
    display: 'flex',
    minWidth: '125px',
    height: 80,
    position: 'relative'
  },
  headerImage: {
    width: '100%',
    objectFit: 'cover',
  },
  overlayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: '3px 0'
  }
});

const mapStateToProps = state => ({
  selectedOpportunity: state.propertyUWState.propertyUWClientTxnOpp,
  user: state.appState.user,
  selectedOpportunityImages: state.propertyUWState.selectedOpportunityImages,
  selectedContainer: state.propertyUWState.selectedContainer,
  viewUnderwriteModalIsOpen: state.exploreMap.viewUnderwriteModalIsOpen
});

const mapDispatchToProps = (dispatch) => ({
  assignTasksTo: (taskType, taskIds, assignToUserId, initiatedUserId) => dispatch(assignTasksTo(taskType, taskIds, assignToUserId, initiatedUserId)),
  unassignTasks: (taskType, taskIds, initiatedUserId) => dispatch(unassignTasks(taskType, taskIds, initiatedUserId)),
  reloadTxnOpps: (txnOppIds) => dispatch(reloadTxnOpps(txnOppIds)),
  setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState)),
  submitPreScreenToUnderwrite: txnOppIds => dispatch(submitPreScreenToUnderwrite(txnOppIds)),
  terminateTxnOpps: (taskIds, reason) => dispatch(terminateTxnOpps(taskIds, reason)),
  unterminateTxnOpps: (txnOppIds) => dispatch(unterminateTxnOpps(txnOppIds)),
  syncPurchaseState: (txnOppIds) => dispatch(syncPurchaseState(txnOppIds)),
  appNotify: (message, variant) => dispatch(appNotify(message, variant)),
  setViewContainersDialogIsOpen: (isOpen) => dispatch(setViewContainersDialogIsOpen(isOpen))
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(HeaderImage);
